import CurrencyInput from './CurrencyInput';

export { default as FakeCurrencyInput } from './FakeCurrencyInput';
export { default as TextWithCursor } from './TextWithCursor';
export { default as formatNumber } from './utils/formatNumber';
export * from './props';

export default CurrencyInput;
